import React from "react";
import styles from "./ViewPassordFormate.module.scss";
import { PASSWORD_INSTRUCTIONS } from "@/lib/constants";
import CrossIcon from "@/components/shared/svg-components/CrossIcon";

const ViewPasswordFormat = ({ onClose }) => {
  return (
    <div className={styles.passwordNotes} onClick={(e) => e.stopPropagation()}>
      <strong>Note: </strong>
      
      <ul>
        {PASSWORD_INSTRUCTIONS.map((instruction) => (
          <li key={instruction}>{`Password must ${instruction}`}</li>
        ))}
      </ul>
    </div>
  );
};

export default ViewPasswordFormat